import React from 'react';

export const PortraitIcon = ({
  width = 24,
  height = 24,
  color = 'currentColor',
}) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5858 8L10 9.58579V22.4142L11.5858 24H20.4142L22 22.4142V9.58579L20.4142 8H11.5858ZM20 10L12 10V22H20V10Z"
      fill={color}
    />
  </svg>
);
